import { render, staticRenderFns } from "./message-config.vue?vue&type=template&id=63a12564&scoped=true"
import script from "./message-config.ts?vue&type=script&lang=ts&external"
export * from "./message-config.ts?vue&type=script&lang=ts&external"
import style0 from "./message-config.scoped.scss?vue&type=style&index=0&id=63a12564&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a12564",
  null
  
)

export default component.exports